(function(){
  function initTpBwg(root){
    if(!root || root.getAttribute('data-tpbwg-init') === '1'){ return; }
    var famScript = root.querySelector('script[data-fams]');
    if(!famScript){ return; }
    var FAMILIES;
    try { FAMILIES = JSON.parse(famScript.textContent); } catch(e){ return; }
    if(!FAMILIES || !FAMILIES.length){ return; }
    root.setAttribute('data-tpbwg-init','1');

    var GRADES = [
      {name:'Neu', price:'voller Preis', lead:'Unbenutzt, keine Gebrauchsspuren. Manche Geräte kommen originalverpackt, manche als Service-/Tausch-Ware in neutraler Verpackung (mit * im Namen). Die oberste Stufe der Skala.'},
      {name:'Wie neu', price:'günstiger als neu', lead:'Generalüberholt: optisch wie neu, geprüft gebraucht. Im Alltag keine sichtbaren Spuren, Akku in der Regel über 95 %.'},
      {name:'Sehr gut', price:'deutlich günstiger', lead:'Generalüberholt mit leichten Gebrauchsspuren, technisch einwandfrei. Akku in der Regel über 90 % – der Preis-Leistungs-Sweetspot.'},
      {name:'Gut', price:'der Spar-Tipp', lead:'Generalüberholt mit sichtbaren Gebrauchsspuren, voll funktionsfähig und geprüft. Akku in der Regel über 85 % – der niedrigste Preis derselben Technik.'}
    ];
    // Akku-freie Lead-Variante für Familien ohne Akku (Festplatten, Haushaltsgeräte, TV …).
    var LEAD_NOAKKU = [
      'Unbenutzt, keine Gebrauchsspuren. Manche Geräte kommen originalverpackt, manche als Service-/Tausch-Ware in neutraler Verpackung (mit * im Namen). Die oberste Stufe der Skala.',
      'Generalüberholt: optisch wie neu, geprüft gebraucht. Im Alltag keine sichtbaren Spuren.',
      'Generalüberholt mit leichten Gebrauchsspuren, technisch einwandfrei. Der Preis-Leistungs-Sweetspot.',
      'Generalüberholt mit sichtbaren Gebrauchsspuren, voll funktionsfähig und geprüft. Der niedrigste Preis derselben Technik.'
    ];
    var SHAPE_ICON = {
      'dev-phone':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2.5"/><path d="M11 5.5h2"/></svg>',
      'dev-watch':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="7" width="10" height="10" rx="2.5"/><path d="M9 7l.5-3h5l.5 3M9 17l.5 3h5l.5-3"/></svg>',
      'dev-laptop':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="5" width="16" height="11" rx="1.5"/><path d="M2 20h20"/></svg>',
      'dev-tv':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="13" rx="2"/><path d="M8 21h8M12 17v4"/></svg>',
      'dev-drive':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="6" rx="1.5"/><rect x="3" y="13" width="18" height="6" rx="1.5"/><path d="M7 8h.01M7 16h.01"/></svg>',
      'dev-washer':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="14" r="4.5"/><path d="M8 5.5h.01M11 5.5h.01"/></svg>'
    };
    var ASPECT_ICON = {
      front:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.5"/><path d="M10 19h4"/></svg>',
      body:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="3"/></svg>',
      funktion:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 8L9 4l-3 8H2"/></svg>',
      akku:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="17" height="10" rx="2"/><path d="M22 10.5v3M6 12h7"/></svg>',
      anschluss:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2v6M15 2v6M7 8h10v2a5 5 0 0 1-10 0z M12 15v7"/></svg>',
      energie:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg>',
      lieferumfang:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="M3 8l9 5 9-5"/><path d="M12 13v8"/></svg>'
    };
    var ASPECT_LABEL = { front:'Display', body:'Gehäuse', funktion:'Funktion', akku:'Akku', anschluss:'Anschlüsse & Zubehör', energie:'Energieeffizienz', lieferumfang:'Lieferumfang' };
    var ASPECT = {
      front:['Makellos, unbenutzt, keine Spuren.','Display makellos, keine sichtbaren Gebrauchsspuren.','Display im Betrieb ohne sichtbare Mängel; feine Mikrokratzer möglich.','Voll funktionsfähig; sichtbare Spuren möglich, im Betrieb nicht störend.'],
      body:['Unbenutzt, keine Spuren.','Keine sichtbaren Gebrauchsspuren im Alltag.','Leichte Spuren möglich – feine Kratzer am Rahmen oder Rücken.','Sichtbare Gebrauchsspuren, evtl. kleine Dellen am Rahmen.'],
      funktion:['Unbenutzt und voll funktionsfähig.','Voll funktionsfähig, einzeln geprüft.','Voll funktionsfähig, einzeln geprüft.','Voll funktionsfähig, einzeln geprüft.'],
      akku:['100 % Kapazität – neu.','In der Regel über 95 % Kapazität, geprüft.','In der Regel über 90 % Kapazität, geprüft.','In der Regel über 85 % Kapazität, geprüft.'],
      anschluss:['Alle Anschlüsse neu; Zubehör original oder neutral (bei *).','Alle Anschlüsse geprüft, Zubehör vollständig oder gleichwertig.','Alle Anschlüsse geprüft; Fernbedienung/Kabel ggf. neutral ersetzt.','Funktion & Anschlüsse geprüft; Lieferumfang kann reduziert sein.'],
      energie:['Energieeffizienzklasse wie ab Werk.','Effizienzklasse unverändert, Technik geprüft.','Effizienzklasse unverändert, Technik geprüft.','Effizienzklasse unverändert; voll funktionsfähig.'],
      lieferumfang:['Hersteller-OVP oder neutrale Verpackung (Service-/Tausch-Ware mit *).','Gerät + passendes Ladekabel (Zubehör ggf. neutral).','Gerät + passendes Ladekabel (Zubehör ggf. neutral).','Gerät + passendes Ladekabel (Zubehör ggf. neutral).']
    };

    var state = { fam: 0, grade: 2 };
    var famTabsEl = root.querySelector('[data-famtabs]');
    var gTabsEl = root.querySelector('[data-gtabs]');
    var stageEl = root.querySelector('[data-stage]');

    function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    function buildFamTabs(){
      var html = '';
      for(var i=0;i<FAMILIES.length;i++){
        var f = FAMILIES[i];
        var ficon = SHAPE_ICON[f.shape] || esc(f.icon || '');
        html += '<button type="button" class="tp-bwg__famtab' + (i===state.fam?' on':'') + '" data-fam="' + i + '">'
             + '<span class="fi">' + ficon + '</span>' + esc(f.label || '') + '</button>';
      }
      famTabsEl.innerHTML = html;
    }
    function buildGTabs(){
      var html = '';
      for(var g=0;g<GRADES.length;g++){
        html += '<button type="button" class="tp-bwg__gtab' + (g===state.grade?' on':'') + '" data-g="' + g + '">' + esc(GRADES[g].name) + '</button>';
      }
      gTabsEl.innerHTML = html;
    }

    function aspectHtml(a, g){
      var label = a.label && a.label.length ? a.label : (ASPECT_LABEL[a.key] || a.key);
      var icon = ASPECT_ICON[a.key] || '';
      // Familie darf je Aspekt eigene Texte mitbringen (copy[grade]); sonst generische ASPECT-Texte.
      var copy = (a.copy && a.copy[g]) ? a.copy[g] : ((ASPECT[a.key] && ASPECT[a.key][g]) ? ASPECT[a.key][g] : '');
      return '<div class="tp-bwg__aspect"><div class="tp-bwg__al"><span class="ai">' + icon + '</span>' + esc(label) + '</div><p>' + esc(copy) + '</p></div>';
    }

    function render(){
      var f = FAMILIES[state.fam];
      var g = state.grade;
      var asp = (f.aspects || []);
      // distribute aspects: left = 0,2 ; right = 1,3
      var left = '', right = '';
      for(var i=0;i<asp.length;i++){
        if(i % 2 === 0){ left += aspectHtml(asp[i], g); } else { right += aspectHtml(asp[i], g); }
      }
      var hasAkku = false;
      for(var j=0;j<asp.length;j++){ if(asp[j].key === 'akku'){ hasAkku = true; } }

      var notch = f.notch ? '<div class="tp-bwg__notch"></div>' : '';
      var dev = '<div class="tp-bwg__device g' + g + ' ' + esc(f.shape) + '"><div class="tp-bwg__face">' + notch
              + '<div class="tp-bwg__glow"></div><div class="tp-bwg__scratch s1"></div><div class="tp-bwg__scratch s2"></div>'
              + '<div class="tp-bwg__scratch s3"></div><div class="tp-bwg__dent"></div></div></div>';

      var akkuBox = hasAkku
        ? '<div class="tp-bwg__akkubox"><div class="tp-bwg__ak"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="17" height="10" rx="2"/><path d="M22 10.5v3M6 12h7"/></svg></div><div><b>Zum Akku – mit klarem Richtwert je Stufe.</b>'
          + '<p>Den Akku prüfen wir bei jedem Gerät mit. Je Stufe gilt als Richtwert: <strong>Wie neu i. d. R. ≥ 95 %</strong>, <strong>Sehr gut ≥ 90 %</strong>, <strong>Gut ≥ 85 %</strong>. Den tatsächlich gemessenen Wert dieses Geräts siehst Du auf der Produktseite.</p></div></div>'
        : '';

      var checks = '';
      if(f.checks && f.checks.length){
        for(var c=0;c<f.checks.length;c++){ checks += '<span>' + esc(f.checks[c]) + '</span>'; }
      }
      var famName = f.name && f.name.length ? f.name : f.label;
      var checkBlock = checks
        ? '<div class="tp-bwg__famcheck"><b>Das prüfen wir an ' + esc(famName) + '</b><div class="tp-bwg__fl">' + checks + '</div></div>'
        : '';
      var noteBlock = (f.note && f.note.length) ? '<div class="tp-bwg__famnote">' + esc(f.note) + '</div>' : '';

      stageEl.innerHTML =
        '<div class="tp-bwg__col">' + left + '</div>'
        + dev
        + '<div class="tp-bwg__col">' + right + '</div>'
        + '<div class="tp-bwg__gradetag"><div class="tp-bwg__gn">' + esc(GRADES[g].name) + '</div><div class="tp-bwg__gp">' + esc(GRADES[g].price) + '</div></div>'
        + '<div class="tp-bwg__gradelead">' + esc(hasAkku ? GRADES[g].lead : LEAD_NOAKKU[g]) + '</div>'
        + akkuBox + checkBlock + noteBlock;

      var fts = famTabsEl.querySelectorAll('.tp-bwg__famtab');
      for(var t=0;t<fts.length;t++){ fts[t].className = 'tp-bwg__famtab' + (t===state.fam?' on':''); }
      var gts = gTabsEl.querySelectorAll('.tp-bwg__gtab');
      for(var u=0;u<gts.length;u++){ var gv = parseInt(gts[u].getAttribute('data-g'),10); gts[u].className = 'tp-bwg__gtab' + (gv===state.grade?' on':''); }
    }

    famTabsEl.addEventListener('click', function(e){
      var btn = e.target.closest ? e.target.closest('.tp-bwg__famtab') : null;
      if(!btn){ return; }
      state.fam = parseInt(btn.getAttribute('data-fam'),10) || 0;
      render();
    });
    gTabsEl.addEventListener('click', function(e){
      var btn = e.target.closest ? e.target.closest('.tp-bwg__gtab') : null;
      if(!btn){ return; }
      state.grade = parseInt(btn.getAttribute('data-g'),10) || 0;
      render();
    });

    var famScroll = famTabsEl.parentNode;
    function updateFade(){
      if(!famScroll || !famScroll.classList){ return; }
      var max = famTabsEl.scrollWidth - famTabsEl.clientWidth;
      var x = famTabsEl.scrollLeft;
      famScroll.classList.toggle('has-left', x > 4);
      famScroll.classList.toggle('has-right', x < max - 4);
    }
    famTabsEl.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);

    buildFamTabs();
    buildGTabs();
    render();
    updateFade();
  }

  function initAll(){
    var roots = document.querySelectorAll('[data-tpbwg]');
    for(var i=0;i<roots.length;i++){ initTpBwg(roots[i]); }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector ? e.target.querySelector('[data-tpbwg]') : null;
    if(el){ initTpBwg(el); }
  });
})();
